import { action } from 'satcheljs';

/**
 * Saves the event
 */
export let saveEvent = action('saveEvent');

/**
 * Saves the event draft
 */
export let saveEventDraft = action('saveEventDraft');

/**
 * Checks properties then saves the event
 */
export let verifyEventThenSave = action('verifyEventThenSave');

/**
 * Prepares the event for the save
 */
export let prepareEvent = action('prepareEvent');

/**
 * Resets the compose form store values to undefined
 */
export let resetComposeStore = action('resetComposeStore');

/**
 * Resets the compose form store values to undefined and resets the location feedback manager
 */
export let resetQuickComposeStore = action('resetQuickComposeStore');
